import OptionGroup from '@/features/pos/components/ProductConfigurationModal/parts/OptionGroup'
import RemovableIngredient from '@/features/pos/components/ProductConfigurationModal/parts/RemovableIngredientGroup/parts/RemovableIngredient'
import { RemovableIngredient as RemovableIngredientType } from '@/features/pos/components/ProductConfigurationModal/types'
import { FC, memo } from 'react'
import { useTranslation } from 'react-i18next'

interface RemovableIngredientGroupProps {
    ingredients: RemovableIngredientType[]
}

const RemovableIngredientGroup: FC<RemovableIngredientGroupProps> = ({ ingredients }) => {
    const { t } = useTranslation()

    return (
        <OptionGroup
            name={t('pos.optionGroup.ingredientsRemoval')}
            minQuantity={0}
            maxQuantity={null}
        >
            {ingredients.map((ingredient) => (
                <RemovableIngredient
                    key={ingredient.id}
                    id={ingredient.id}
                    name={ingredient.name}
                />
            ))}
        </OptionGroup>
    )
}

export default memo(RemovableIngredientGroup)
